/**
 * PATH: packages/job-hub/src/jobs/client/routeTypes.ts
 * FILE_ID: JOBHUB-JOBS-CLIENT-TYPES-001
 * PURPOSE: Shared contract for the Django route-table modules — DjangoRoute
 *          descriptor, Verb, the ID segment regex, and the RouteContext each
 *          segment resolver receives.
 * WHY: S4 rank-12 decomposition of djangoJobHubClient.ts. Route ORDER is a
 *      correctness property (route-order traps: literal segments must beat
 *      :id catch-alls) — resolvers run sequentially and return null to pass.
 */
export type Verb = 'get' | 'post' | 'put' | 'patch' | 'delete'

/** A resolved route: forward to Django, or answer synthetically (no HTTP). */
export interface DjangoRoute {
  kind: 'http' | 'synthetic' | 'reject'
  method?: Verb
  /** Django path; params from the original config are forwarded + merged. */
  url?: string
  /** Extra query params to merge into the forwarded request. */
  params?: Record<string, unknown>
  /** Post-process the Django ``response.data`` into the hub shape. */
  reshape?: (data: unknown) => unknown
  /** Canned payload for ``synthetic`` routes (siblings, folder create). */
  synthetic?: unknown
  /** Human message for ``reject`` routes (unsupported on standard API). */
  rejectReason?: string
}

export const ID = '([^/?]+)' // a path segment that isn't a slash or query

/** Everything a segment resolver needs. `match` anchors on the full path. */
export interface RouteContext {
  verb: Verb
  rawUrl: string
  path: string
  match: (re: string) => RegExpMatchArray | null
  /** ``?tenant=<orgId>`` for the platform job-schedule endpoints. */
  tenantParam: Record<string, unknown> | undefined
  requestParams?: Record<string, unknown>
}

/** One ordered segment of the route table. Returns null to fall through. */
export type SegmentResolver = (ctx: RouteContext) => DjangoRoute | null
